import React, {Component} from 'react';
import {connect} from 'react-redux';
import MaterialButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { clearErrors, clearMessages } from '../actions/messages';

/**
 * Material UI button 
 * with circular progress when "working" prop is true
 * and default corresponding to the theme (small, primary color)
 * Also, any click on a button will clear error and messages
 * 
 */

const styles = theme => ({
  progress: {
    marginRight: theme.spacing.unit
  }
})

class Button extends Component {
  handleClick() {
    const {onClick, clearMessagesAndErrors} = this.props;
    clearMessagesAndErrors();
    onClick();
  }
  render() {
    const {classes, working, children, onClick, clearMessagesAndErrors, ...props} = this.props;
    return (
      <MaterialButton 
        color="primary"
        size="small"
        onClick={e=>this.handleClick(e)}
        {...props}
      >
        {working && <CircularProgress className={classes.progress} color="inherit" size={16}/>}
        {children}
      </MaterialButton>
    )
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  clearMessagesAndErrors: () => {
    dispatch( clearErrors() );
    dispatch( clearMessages() );
  }
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Button)
);


// WEBPACK FOOTER //
// ./src/components/Button.js